import { LinkButton, PrimaryButton } from "@digipost/dds-buttons-react";
import { Infobox } from "@digipost/dds-infobox-react";
import { FC } from "react";
import { useNavigate } from "react-router";

import { DigipostEntryPoint } from "../../../types/entrypoint";
import { useEntrypointContext } from "../EntrypointContext";
import Translated from "../infrastructure/components/Translated";
import { useRootPath } from "../infrastructure/hooks/useRootPath";
import { useTranslate } from "../infrastructure/hooks/useTranslate";
import styles from "./EpostVerifisering.module.less";

export const EpostVerifiseringFeilet: FC = () => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const entrypoint: DigipostEntryPoint = useEntrypointContext();
  const isLoggedIn = !!entrypoint && !!entrypoint.role;
  const isLoggedInAsPrivate = isLoggedIn && entrypoint.role === "PRIVAT";
  const rootPath = useRootPath();

  return (
    <>
      <Infobox
        title={translate("verify.failed.header")}
        variant={"error"}
        level={2}
      >
        <Translated textKey={"verify.failed"} />
      </Infobox>
      {isLoggedInAsPrivate ? (
        <div>
          <LinkButton onClick={() => navigate(rootPath)}>
            {translate("verify.redirect")}
          </LinkButton>
        </div>
      ) : (
        <div className={styles.verificationContentLogin}>
          <PrimaryButton onClick={() => navigate(rootPath)}>
            {translate("login.generic")}
          </PrimaryButton>
        </div>
      )}
    </>
  );
};
